import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { LoadingAnimation } from './loading-animation'

import styles from './loading-indicator.module.css'

const propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    classNameAnimation: PropTypes.string,
    classNameAnimationCircle: PropTypes.string,
    isLoading: PropTypes.bool,
    noDelay: PropTypes.bool
}

const defaultProps = {
    isLoading: false,
    noDelay: false
}

/**
 * Basic loading indicator view to render a wrapper with corresponding children.
 *
 * @example <caption>Basic Usage</caption>
 * <code>
 * <LoadingIndicator isLoading={true|false}>
 *      <YourComponent />
 * </LoadingIndicator>
 * </code>
 *
 * @param {Object} props - Current component properties
 * @param {ReactElement} [props.children] - JSX children to be rendered
 * @param {string} [props.className] - Optional className for the loader view
 * @param {string} [props.classNameAnimation] - Optional className for the loader animation
 * @param {boolean} [props.isLoading=false] - Basic flag to toggle between loading animation and children
 * @returns {ReactElement}
 */
function LoadingIndicator(props) {
    const { children, className, classNameAnimation, classNameAnimationCircle, isLoading, noDelay } = props
    const combinedClassName = cx(styles['loading-indicator'], className, 't3sel-loading-indicator')
    const animationContainer = cx(
        styles['loading-indicator-animation'],
        classNameAnimation,
        't3sel-loading-indicator-animation'
    )
    return (
        <div className={combinedClassName}>
            {isLoading && (
                <div className={animationContainer} role="presentation">
                    <LoadingAnimation noDelay={noDelay} circleClassName={classNameAnimationCircle} />
                </div>
            )}
            {children}
        </div>
    )
}

LoadingIndicator.propTypes = propTypes
LoadingIndicator.defaultProps = defaultProps

export { LoadingIndicator }
